import React from 'react';
import { Wrapper, Title, Select, Icon, OptionWrapper, Option, OptionTag } from './Styled';

import icon from './down-arrow.svg';


const KEY_UP = 38;
const KEY_DOWN = 40;
const KEY_ENTER = 13;
const KEY_SPACEBAR = 32;
const KEY_TAB = 9;

export default class Dropdown extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            cursor: null,
            renderBg: false,
            renderMenu: false,
            selectedOption: this.props.selected,
            tags: this.props.tags,
            hasIcons: this.props.hasOptionIcons,
        };
    }

    componentWillReceiveProps(nextProps) {
        if(this.state.selectedOption !== nextProps.selected) {
            this.setState({
                selectedOption: nextProps.selected
            });
        }
    }

    handleChange = (selected, index) => {
        if (selected.label !== undefined) {
            this.props.handleChange(selected.label, selected.direction, index);
        } else {
            this.props.handleChange(selected, index);
        }

        this.handleOnBlur();
    }

    handleOnFocus = () => {
        this.setState({ renderBg: !this.state.renderBg});
    }

    handleOnBlur = () => {
        this.setState({ renderBg: false, renderMenu: false });
    }

    handleOnClick = () => {
        this.setState({ renderMenu: !this.state.renderMenu});
    }

    handleKeydown = (e) => {
        if (e.keyCode !== KEY_TAB) {
            e.preventDefault();
        }

        let cursor = this.state.cursor;
        let options = this.props.options;

        if (this.state.hasIcons) {
            options = options.map((o) => {
                return o.label;
            });
        }

        options.forEach(option => {
            if (option.toLowerCase().startsWith(String.fromCharCode(e.keyCode).toLowerCase())) {
                this.setState({selectedOption: option});
                return;
            }
        });

        if (e.keyCode === KEY_SPACEBAR || e.keyCode === KEY_ENTER)  {
            e.preventDefault();
            this.handleOnClick();
        }

        if (e.keyCode === KEY_UP) {
            if (cursor === null) {
                cursor = options.length - 1;
            } else if (cursor === 0) {
                cursor = options.length - 1;
            } else {
                cursor--;
            }
        } else if (e.keyCode === KEY_DOWN) {
            if (cursor === null) {
                cursor = 0;
            } else if (cursor === options.length - 1) {
                cursor = 0;
            } else {
                cursor++;
            }
        }
        this.setState({ cursor });

        /**
         * ENTER DROPDOWN FUNCTIONALITY
         * if you select an option by arrow keys then enter, selectedOption is populated,
         * if selectedOption is a valid value - call handleChange function
         */
        let selectedOption = this.state.selectedOption;
        let startOfSelectedOption = selectedOption.substring(0, 6);

        if (e.keyCode === KEY_ENTER && selectedOption !== null && cursor === null) {
            if (startOfSelectedOption !== 'Select' && this.props.selected !== selectedOption) {
                this.handleChange(selectedOption, cursor);
            } else {
                this.handleOnClick();
            }
            return;
        } else if (e.keyCode === KEY_ENTER && cursor !== null) {
            this.setState({selectedOption: options[cursor], renderMenu: !this.state.renderMenu, cursor: null})

            this.handleChange(this.props.options[cursor], cursor);
        }
    }

    render() {
        const tagDropdown = this.state.tags;
        if (this.state.renderMenu) {
            var dropdownListItems = (
                <OptionWrapper className={this.props.optionWrapperClassName} menuActive={this.state.renderMenu}>
                    {
                        this.props.options.map((optionItem, index) => {
                            var active = false;
                            if (this.state.cursor === index) {
                                active = true;
                            }

                            let option;
                            if (this.state.hasIcons) {
                               option = <div>{optionItem.label}<i className={`fa fa-arrow-${optionItem.direction} green pull-right pt-1`} aria-hidden="true"></i></div>
                            } else if (this.props.tags) {
                                option = <div>{optionItem.name}</div>
                            } else {
                                option = <div>{optionItem}</div>
                            };

                            if (tagDropdown) {
                                return (
                                    <OptionTag
                                        id={`dropdown-tag-item-${index}`}
                                        suppressContentEditableWarning={true}
                                        contentEditable="false"
                                        onClick={() => {
                                        this.setState({
                                            selectedOption: optionItem.name,
                                        });
                                            this.handleChange(optionItem, index);
                                        }}
                                        key={index}
                                        active={active}>
                                        {option}
                                    </OptionTag>)
                            } else {
                                return (
                                <Option
                                    id="dropdown-item"
                                    suppressContentEditableWarning={true}
                                    contentEditable="false"
                                    onClick={() => {
                                    this.setState({
                                        selectedOption: this.state.hasIcons ? optionItem.label : optionItem,
                                        renderMenu: false
                                    });

                                    this.handleChange(optionItem, index);

                                    }}
                                    key={index}
                                    active={active}>
                                    {option}
                                </Option>)
                            }
                        })
                    }
                </OptionWrapper>
            );
        }

        return (
                <Wrapper className={this.props.className} id={this.props.id} readonly contentEditable suppressContentEditableWarning tabindex="0"
                    hasIcons={this.state.hasIcons}
                    fieldActive={this.state.renderBg}
                    onKeyDown={this.handleKeydown}
                    onClick={this.handleOnClick}
                    onBlur={this.handleOnBlur}
                    onFocus={this.handleOnFocus}>
                    <Title hasIcons={this.state.hasIcons} fieldActive={this.state.renderBg} suppressContentEditableWarning contentEditable="false">{this.props.title}</Title>
                    <Select className={this.props.selectClassName} suppressContentEditableWarning fieldActive={this.state.renderBg} menuActive={this.state.renderMenu} contentEditable="false" >
                        {this.state.selectedOption}<Icon alt="dropdown icon" src={icon} height="15" />
                    </Select>
                    {dropdownListItems}
                </Wrapper>

        );
    }
}




// WEBPACK FOOTER //
// ./src/components/Dropdown/Dropdown.js